var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "#7BAD2D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_45376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5 30.5672L27.584 30.9052C28.0686 31.0651 28.596 31.0338 29.0583 30.8176C29.5205 30.6014 29.8826 30.2167 30.0705 29.7422L31.3205 26.2422C32.1955 23.7867 29.7705 21.4187 27.1115 22.1297L26.5 22.2912L25.891 22.1282C23.2305 21.4172 20.807 23.7852 21.682 26.2407L22.932 29.7407C23.1198 30.2152 23.482 30.5999 23.9442 30.8161C24.4065 31.0323 24.9339 31.0636 25.4185 30.9037L26.5 30.5672Z",
    stroke: "#7BAD2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19H23",
    stroke: "#7BAD2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5H18",
    stroke: "#7BAD2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 26H18",
    stroke: "#7BAD2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 31H10.5V12.5H12.5",
    stroke: "#7BAD2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 12.5H28.5V15.5",
    stroke: "#7BAD2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 11.5C22 10.837 21.7366 10.2011 21.2678 9.73223C20.7989 9.26339 20.163 9 19.5 9C18.837 9 18.2011 9.26339 17.7322 9.73223C17.2634 10.2011 17 10.837 17 11.5H15V14.5H24V11.5H22Z",
    stroke: "#7BAD2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 17.5V18C29 18.3283 28.9353 18.6534 28.8097 18.9567C28.6841 19.26 28.4999 19.5356 28.2678 19.7678C28.0356 19.9999 27.76 20.1841 27.4567 20.3097C27.1534 20.4353 26.8283 20.5 26.5 20.5V20C26.5 19.337 26.7634 18.7011 27.2322 18.2322C27.7011 17.7634 28.337 17.5 29 17.5Z",
    fill: "#7BAD2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_45376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8.5 8)"
  })))));
};
export default __webpack_public_path__ + "static/media/ic_nutrition.44847702.svg";
export { SvgComponent as ReactComponent };